// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol } from 'mdbreact';
import { Field } from 'redux-form';
import TimePickedField from '../../layout/reduxForm/customFields/TimePickerField';

const TimeSection = () => (
  <div className="fields_group">
    <div className="field_col field_col--shrink">
        <div className="field_block">
      <Field
        name="startTime"
        component={TimePickedField}
        label="Start Time"
      />
        </div>
    <div className="field_block">
      <Field
        name="endTime"
        component={TimePickedField}
        label="End Time"
      />
    </div>
    </div>
  </div>
);

export default TimeSection;
